export default "__VITE_ASSET__DCdR_h2J__"